import {connect} from 'react-redux';
import Question from "../ui/Question";
import C from '../../constants';

const mapStateToProps = state => {
    let question = state.questions.find(q => q.id === state.testData.currentQId);
    return {
        question: question,
        isLoading: state.isProcessing
    }
};

const mapDispatchToProps = dispatch => {
    return {
        setQuestionResult(result) {
            dispatch({
                type: C.SET_QUESTION_RESULT,
                payload: result
            })
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Question)
